import { render, staticRenderFns } from "./list-table-businessboard.vue?vue&type=template&id=25d7f7c4&scoped=true"
import script from "./list-table-businessboard.vue?vue&type=script&lang=js"
export * from "./list-table-businessboard.vue?vue&type=script&lang=js"
import style0 from "./list-table-businessboard.vue?vue&type=style&index=0&id=25d7f7c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25d7f7c4",
  null
  
)

export default component.exports